var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"client-code",on:{"click":_vm.showOverlay}},[_vm._v(_vm._s(_vm.custno))])}
var staticRenderFns = []

export { render, staticRenderFns }